// @flow

import { routerMiddleware } from 'connected-react-router'
import history from './history';

const routerMiddlewareWithHistory = routerMiddleware(history);

export default routerMiddlewareWithHistory;
